export const basePalette = {
  accent: "#1B67BC",
  black: "#000000",
  grey: "#E1E1E1",
  white: "#FFFFFF",
  darkGrey: "#DADADA",
  lightGrey: "#979797",
  error: "#E90E0E",
  warning: "#F68A20",
};

type ThemeColorOverrides = {
  accent?: string;
  black?: string;
  grey?: string;
  white?: string;
  darkGrey?: string;
  lightGrey?: string;
  error?: string;
  warning?: string;
};

const getThemeOverrides = (): ThemeColorOverrides | undefined => {
  if (typeof window === "undefined") {
    return undefined;
  }

  return window.sjdBookingThemePalette as ThemeColorOverrides | undefined;
};

const applyThemeOverrides = () => {
  const overrides = getThemeOverrides();
  if (!overrides) return basePalette;

  const { accent, black, grey, white, darkGrey, lightGrey, error, warning } =
    overrides;

  return {
    accent: accent ?? basePalette.accent,
    black: black ?? basePalette.black,
    grey: grey ?? basePalette.grey,
    white: white ?? basePalette.white,
    darkGrey: darkGrey ?? basePalette.darkGrey,
    lightGrey: lightGrey ?? basePalette.lightGrey,
    error: error ?? basePalette.error,
    warning: warning ?? basePalette.warning,
  } as typeof basePalette;
};

export const palette = applyThemeOverrides();

declare global {
  interface Window {
    sjdBookingThemePalette?: ThemeColorOverrides;
  }
}
